<script setup lang="ts">
// import { parseErrors } from "@/assets/js/parseErrors";
import { useToastStore } from "@/store/toast";
// import api from "@/api";
// import { useDefaultStore } from "@/store";
import { useExpenseTemp } from "@/store/expensesTemp";
import { useTempStoreOptions } from "@/store/tempOptions";
import dayjs from "dayjs";
import ReceiptForm from "@/components/tempExpenses/ReceiptForm.vue";

const emit = defineEmits(["close-modal", "confirm"]);

const userStoreOpt = useTempStoreOptions();
const expenseStore = useExpenseTemp();
const toast = useToastStore();

const expenseTypes = computed(() => expenseStore.expenseTypes);

const expenseType = ref<any>(null);
const previewData = ref<any>(null);
const ping = ref<any>(0);
const expenseTypeEnum = computed(() => expenseStore.expenseTypeEnum);

function selectType(obj: any) {
	previewData.value = null;
	expenseType.value = obj;
}
const vehicleTypeEnum = computed(() => {
	return expenseStore.vehicleTypeEnum;
});
async function init() {
	await userStoreOpt.getUserProfile();
	await expenseStore.fetchExpensesTypes();
	expenseType.value = expenseTypes.value[0];
}

const isMileage = computed(() => {
	return (
		expenseTypeEnum.value[expenseType.value?.id] ===
		expenseTypeEnum.value.MILEAGE
	);
});

const isSubsistence = computed(() => {
	return (
		expenseTypeEnum.value[expenseType.value?.id] ===
		expenseTypeEnum.value.SUBSISTENCE
	);
});
const isReceipt = computed(() => {
	return (
		expenseTypeEnum.value[expenseType.value?.id] ===
		expenseTypeEnum.value.RECEIPT
	);
});

const canPreview = computed(() => {
	if (isMileage.value) {
		return (
			previewData.value &&
			previewData.value.client &&
			previewData.value.vehicleType &&
			// previewData.value.startTime &&
			// previewData.value.endTime &&
			previewData.value.location &&
			previewData.value.category &&
			previewData.value.startDate &&
			previewData.value.endDate &&
			(previewData.value.engineType ||
				previewData.value.vehicleType.id ===
					vehicleTypeEnum.value?.BICYCLE?.id) &&
			previewData.value.distance &&
			previewData.value.travelFrom &&
			previewData.value.travelTo
		);
	}
	if (isSubsistence.value)
		return (
			previewData.value &&
			previewData.value.band &&
			previewData.value.client &&
			previewData.value.location &&
			previewData.value.category &&
			// previewData.value.startTime &&
			// previewData.value.endTime &&
			previewData.value.startDate &&
			previewData.value.endDate &&
			previewData.value.locationOfSubsistence
		);
	if (isReceipt.value) {
		return (
			previewData.value &&
			previewData.value.reason &&
			previewData.value.client &&
			previewData.value.location &&
			previewData.value.category &&
			previewData.value.date &&
			previewData.value.file &&
			previewData.value.amount
		);
	}
});

const showPreviewExpense = ref(false);

async function createExpenses() {
	if (canPreview.value && checkData()) {
		await expenseStore.checkCutoff();
		// console.log(getDataWithType());
		showPreviewExpense.value = true;
		// window.scrollTo({ top: 0, behavior: "smooth" });
		modalRef.value.scrollTop = 0;
		// this.navigate("/preview-expense/", {
		// 	props: {
		// 		data: getDataWithType(),
		// 	},
		// });
	} else {
		ping.value++;
	}
}

function checkData() {
	console.log("ssss");
	if (isSubsistence.value) {
		const p = previewData.value;
		console.log(p);
		if (!p) {
			// toast.openToastError(`Please fill all required fields.`);
			return false;
		}
		const mStart = dayjs(p?.startDate, "DD-MM-YYYY HH:mm");
		const mEnd = dayjs(p?.endDate, "DD-MM-YYYY HH:mm");
		// get difference in hours
		const diff = mEnd.diff(mStart, "hours", true);
		const band = p?.band;
		let error = null;

		if (band?.to) {
			if (diff < band.from || diff > band.to) {
				error =
					"Subsistence time must be between " +
					band.from +
					" and " +
					band.to +
					" hours for selected band.";
			}
		} else {
			if (diff < band?.from) {
				error =
					"Subsistence time must be higher than " +
					band.from +
					" hours for selected band.";
			}
		}

		if (error) {
			toast.openToastError(error);
			return false;
		}
		return true;
	}
	return true;
}

function getDataWithType() {
	const data = JSON.parse(JSON.stringify(previewData.value));
	// console.log(this.expenseType);
	if (isSubsistence.value) data.type = expenseType.value?.id;
	if (previewData.value?.file) data.file = previewData.value.file;
	return data;
}

function handleData(data: any) {
	previewData.value = { ...data };
	// console.log("data: " + previewData.value);
}
function success() {
	showPreviewExpense.value = false;
	emit("confirm");
	emit("close-modal");
	console.log("refresh data");
}
onMounted(() => {
	init();
});

onUnmounted(() => {
	expenseType.value = null;
});
const modalRef = ref();
</script>
<template>
	<div
		ref="modalRef"
		class="new-expense-container"
	>
		<preview-expense
			v-if="showPreviewExpense"
			:data="getDataWithType()"
			@return="showPreviewExpense = false"
			@success="success"
		/>
		<div
			v-show="!showPreviewExpense"
			class="content"
		>
			<div class="wrapp-inputs">
				<div class="group">
					<label class="label">Select expense type</label>
					<multiselect-form
						v-model="expenseType"
						:options="expenseTypes"
						label="name"
						placeholder="Please select type"
						value-prop="id"
						:multiple="false"
						:showLabels="true"
						:searchable="true"
						@select="selectType"
					/>
				</div>
				<div class="line"></div>
				<mileage-form
					v-if="isMileage"
					:ping="ping"
					@change="handleData"
				/>
				<subsistence-form
					v-if="isSubsistence"
					:ping="ping"
					@change="handleData"
				/>
				<ReceiptForm
					v-if="isReceipt"
					:ping="ping"
					@change="handleData"
				/>
			</div>
			<div class="buttons-centered">
				<button
					class="button alt"
					@click.prevent="emit('close-modal')"
				>
					Cancel
				</button>
				<button
					class="button"
					:disabled="expenseType === null"
					@click="createExpenses"
				>
					Create
				</button>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
$color-light-gray: #dde6eb;
$color-fa: #7c91ae;
$background-color-price: #e7edf4cc;

.new-expense-container {
	width: 589px;
	// overflow: hidden;
	// height: calc(100vh - 150px);
	height: 600px;
	// overflow-y: auto;
	box-sizing: border-box;
	padding: 0 20px 35px;
	margin-bottom: 10px !important;
	overflow: auto;

	.content {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	label {
		color: $label-accent-color;
		text-align: right;
		// width: 40px;
		margin-top: 5px;
		margin-right: 10px;
	}
	.line {
		height: 1px;
		background-color: $input-border-color;
		margin: 35px 0 15px;
	}
	.buttons-centered {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: auto;
		button.button {
			margin: 17px 0.3em;
			min-width: 90px;
			height: 30px;
		}
	}
}
</style>
